import script from "./BurgerMenu.vue?vue&type=script&setup=true&lang=js"
export * from "./BurgerMenu.vue?vue&type=script&setup=true&lang=js"

import "./BurgerMenu.vue?vue&type=style&index=0&id=54858fea&scoped=true&lang=scss"
import "./BurgerMenu.vue?vue&type=style&index=1&id=54858fea&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-54858fea"]])

export default __exports__